import { styled } from "styled-components";

const StyledParagraph = styled.p`
  margin: 0 40px 0 40px;
`;

export default StyledParagraph;
